// src/apis/projectApi.js
import apiClient from "../utils/apiClient";

// reusable error normalizer
const handleApiError = (error, defaultMessage) => {
  console.error(defaultMessage, error);

  throw {
    status: error.response?.status,
    message:
      error.response?.data?.message ||
      error.response?.data?.detail ||
      defaultMessage,
    data: error.response?.data || null,
  };
};

// apis/projectApi.js

export const fetchProjectById = async (projectId) => {
  try {
    const response = await apiClient.get(`/projects/${projectId}/`);
    
    // Important: return the inner data object
    if (response.data?.status === "success") {
      return response.data.data;           // ← the actual project
    }
    
    throw new Error(response.data?.message || "Failed to load project");
    
  } catch (error) {
    const message =
      error.response?.data?.message ||
      error.response?.data?.detail ||
      error.message ||
      "Failed to load project details";
    
    throw new Error(message);
  }
};
// FETCH projects
export const fetchProjects = async (params = {}) => {
  try {
    const response = await apiClient.get("/projects/", { params });
    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to fetch projects.");
  }
};


// CREATE project
export const createProject = async (formData) => {
  try {
    const response = await apiClient.post("/projects/", formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to create project.");
  }
};


// UPDATE project
export const updateProject = async (id, formData) => {
  try {
    const response = await apiClient.patch(`/projects/${id}/`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
    });

    return response.data;
  } catch (error) {
    handleApiError(error, "Failed to update project.");
  }
};


// CREATE project assignment
export const createProjectAssignment = async (assignmentData) => {
  try {
    const formData = new FormData();

    Object.entries(assignmentData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });

    const response = await apiClient.post(
      "/projects/assignments/",
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to create project assignment.");
  }
};

// UPDATE project assignment
export const updateProjectAssignment = async (assignmentId, assignmentData) => {
  try {
    const formData = new FormData();

    Object.entries(assignmentData).forEach(([key, value]) => {
      if (value !== undefined && value !== null && value !== "") {
        formData.append(key, value);
      }
    });

    const response = await apiClient.patch(
      `/projects/assignments/${assignmentId}/`,
      formData,
      {
        headers: { "Content-Type": "multipart/form-data" },
      }
    );

    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to update project assignment.");
  }
};
// DELETE project
export const deleteProjectApi = async (id) => {
  try {
    const response = await apiClient.delete(`/projects/${id}/`);
    return response.data;

  } catch (error) {
    handleApiError(error, "Failed to delete project.");
  }
};
